import React from "react";
import moment from "moment";
import { Flex, Box } from "grid-styled";
import { Field, reduxForm } from "redux-form";
import Button, { LinkButton } from "./Button";
import { H1 } from "./Heading";
import {
  FormSection,
  InputContainer,
  Select,
  DatePicker,
  AddressFields
} from "./forms";
import { FRANCHISE_CERTIFICATION_STATUSES } from "../constants";

const CERTIFICATION_STATUS_OPTIONS = FRANCHISE_CERTIFICATION_STATUSES.map(
  status => ({
    value: status,
    label: status
  })
);

const validate = values => {
  return {};
};

const FranchiseEditForm = ({
  newFranchise,
  pristine,
  submitting,
  handleSubmit
}) => (
  <Box p={3}>
    <form onSubmit={handleSubmit}>
      <H1>{newFranchise ? "Add a new franchise" : "Update franchise"}</H1>
      <FormSection title="Franchise Info">
        <Box pb={2}>
          <Field
            name="name"
            labelText="Name"
            placeholder="e.g., Augusta"
            component={InputContainer}
          />
        </Box>
        <Box pb={2}>
          <Field
            name="corporateName"
            labelText="Corporate Name"
            placeholder="e.g., Augusta Construction, LLC."
            component={InputContainer}
          />
        </Box>
        <Flex mx={-2} wrap>
          <Box w={[1, 1 / 2]} px={2} pb={2}>
            <Field
              name="assignedInHouseTty"
              labelText="Assigned In-House TTY"
              placeholder="e.g., 001"
              component={InputContainer}
            />
          </Box>
          <Box w={[1, 1 / 2]} px={2} pb={2}>
            <Field
              name="certificationStatus"
              labelText="Certification Status"
              component={InputContainer}
              fieldComponent={Select}
              options={CERTIFICATION_STATUS_OPTIONS}
            />
          </Box>
        </Flex>
        <Flex mx={-2} wrap>
          <Box w={[1, 1 / 2]} px={2} pb={2}>
            <Field
              name="franchiseAgreementEffectiveOn"
              labelText="Franchise Agreement Effective On"
              component={InputContainer}
              fieldComponent={DatePicker}
            />
          </Box>
          <Box w={[1, 1 / 2]} px={2} pb={2}>
            <Field
              name="franchiseAgreementExpiresOn"
              labelText="Franchise Agreement Expires On"
              component={InputContainer}
              fieldComponent={DatePicker}
            />
          </Box>
        </Flex>
        <Flex mx={-2} wrap>
          <Box w={[1, 1 / 2]} px={2} pb={2}>
            <Field
              name="chatmeterId"
              labelText="ChatMeter ID"
              component={InputContainer}
            />
          </Box>
        </Flex>
      </FormSection>
      <FormSection title="Office Address">
        <AddressFields name="Street Address" path="address" />
      </FormSection>
      <FormSection title="Mailing Address">
        <AddressFields name="Street Address" path="mailingAddress" />
      </FormSection>
      <FormSection>
        <Button
          variant="primary"
          disabled={pristine || submitting}
          type="submit"
        >
          {newFranchise ? "Create" : "Update"} franchise
        </Button>
        <LinkButton to="/admin/franchises" style={{ marginLeft: 4 }}>
          Cancel
        </LinkButton>
      </FormSection>
    </form>
  </Box>
);

export default reduxForm({
  form: "franchiseEdit",
  validate,
  initialValues: {
    franchiseAgreementEffectiveOn: moment(),
    franchiseAgreementExpiresOn: moment().add(1, "year")
  }
})(FranchiseEditForm);



// WEBPACK FOOTER //
// ./src/components/FranchiseEditForm.js